export const CircleCheck = ({ size = 14 }) => (
  <svg width={size} height={size} fill="none" viewBox="0 0 14 14" aria-hidden="true">
    <circle cx="7" cy="7" r="6" stroke="var(--gold)" strokeWidth="1.2" />
    <path d="M4.5 7.5l2 2 3.5-3.5" stroke="var(--gold)" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const SmallCheck = () => (
  <span className="cicon">
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">
      <path d="M2 5.5l2 2 4-4" stroke="var(--gold)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </span>
);

export const DocIcon = () => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" style={{ margin: "0 auto 6px", display: "block" }} aria-hidden="true">
    <rect x="6" y="3" width="13" height="17" rx="2" stroke="var(--fg-soft)" strokeWidth="1.3" />
    <path d="M10 8h6M10 12h6M10 16h3.5" stroke="var(--fg-soft)" strokeWidth="1.2" strokeLinecap="round" />
    <path d="M17 1v5h5" stroke="var(--gold)" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const GateMark = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true">
    <path d="M5 29V13a11 11 0 0 1 22 0v16" stroke="var(--gold)" strokeWidth="2.4" strokeLinecap="round" />
    <path d="M11.5 29V12.5M16 29V10M20.5 29V12.5" stroke="var(--gold)" strokeWidth="2" strokeLinecap="round" />
    <path d="M3 29h26" stroke="var(--gold)" strokeWidth="2.4" strokeLinecap="round" />
  </svg>
);

export const GateArt = () => (
  <svg viewBox="0 0 760 760" fill="none" aria-hidden="true">
    <path d="M110 760V330a270 270 0 0 1 540 0v430" stroke="currentColor" strokeWidth="3" />
    <path d="M150 760V340a230 230 0 0 1 460 0v420" stroke="currentColor" strokeWidth="1.2" />
    {[230, 305, 380, 455, 530].map((x) => (
      <path key={x} d={`M${x} 760V${x === 380 ? 112 : x === 305 || x === 455 ? 128 : 178}`} stroke="currentColor" strokeWidth="2" />
    ))}
    <path d="M150 470h460M150 500h460" stroke="currentColor" strokeWidth="1.2" />
    <circle cx="380" cy="300" r="34" stroke="currentColor" strokeWidth="2" />
  </svg>
);
